import * as React from 'react';
import { Grid, GridColumn as Column, GridFilterChangeEvent, GridPageChangeEvent } from '@progress/kendo-react-grid';
import { filterBy } from '@progress/kendo-data-query';
import { EditSurveyContext } from './../common/context';
import EditSurveyButton from './EditSurveyButton';
import StatusSurveyButton from './StatusSurveyButton';
import ConfirmationComponent from '../common/notification/ConfirmationComponent';
import { DELETE_CONFIRAMATION } from 'src/constants/NotificationMessageConstant';

export default class SurveyListComponent extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            surveyId: 0,
            isConfirmDialogShow: false
        }
        this.deleteSurvey = this.deleteSurvey.bind(this);
        this.handleDialogSubmit = this.handleDialogSubmit.bind(this);
        this.onCloseConfirmation = this.onCloseConfirmation.bind(this);
    }

    updateSurveyListPage = (event: GridPageChangeEvent) => {
        this.props.updateSurveyListPage(event.page);
    }

    updateSurveyListFilter = (event: GridFilterChangeEvent) => {
        this.props.updateSurveyListFilter(event.filter)
        this.props.updateSurveyListPage({ skip: 0, take: 10 });
    }

    deleteSurvey(surveyId: number) {
        this.setState({ surveyId, isConfirmDialogShow: true });
    }

    handleDialogSubmit() {
        this.props.deleteSurvey(this.state.surveyId);
        this.setState({ isConfirmDialogShow: false });
    }

    onCloseConfirmation() {
        this.setState({
            isConfirmDialogShow: false
        });
    }

    render() {
        return (
            <EditSurveyContext.Provider value={{
                deleteSurvey: this.deleteSurvey
            }}>
                <ConfirmationComponent handleDialogSubmit={this.handleDialogSubmit} onCloseConfirmation={this.onCloseConfirmation} message={DELETE_CONFIRAMATION} open={this.state.isConfirmDialogShow} />
                <div className="kendoWrapper">
                    <Grid
                        data={filterBy(this.props.surveys, this.props.filter).slice(this.props.skip, this.props.take + this.props.skip)}
                        filterable={true}
                        filter={this.props.filter}
                        onFilterChange={this.updateSurveyListFilter}
                        skip={this.props.skip}
                        take={this.props.take}
                        total={filterBy(this.props.surveys, this.props.filter).length}
                        pageable={true}
                        onPageChange={this.updateSurveyListPage}
                    >
                        <Column field="" title="Status" filterable={false} cell={StatusSurveyButton} />
                        <Column field="title" title="Survey Title" filterable={true} className="title" />
                        <Column field="surveyPeriod" title="Survey Period" filterable={true} />
                        <Column field="updatedDateText" title="Last Edited" filterable={true} />
                        <Column field="updatedBy" title="Last Edited By" filterable={true} />
                        <Column field="surveyType" title="Survey Type" filterable={true} cell={(props) => {
                            return (
                                <td>
                                    {props.dataItem.surveyType === 1 ? 'Global' : 'Regional'}
                                </td>
                            );
                        }} />
                        <Column field="" title="" className="EditSurvey" filterable={false} cell={EditSurveyButton} />
                    </Grid>
                </div>
            </EditSurveyContext.Provider>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/surveys/SurveyListComponent.tsx